import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { CreateTeamInput, CreateTeamOutput, WebAppRoutes } from "types/web-app";

export const createPokeTeam = async (
  accessToken: string,
  input: CreateTeamInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.CREATE_POKE_TEAM,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<CreateTeamOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
